// Keys MUST match app/services/feature_flags/registry.py (FeatureFlag enum) exactly.
export const FeatureFlags = {
  TEBRA_ENABLED: 'tebra_enabled',
  SESSION_NOTES_V2_ENABLED: 'session_notes_v2_enabled',
  DATA_DASHBOARD_V2_ENABLED: 'data_dashboard_v2_enabled',
  QUESTIONNAIRE_ENABLED: 'questionnaire_enabled',
  TREATMENT_PLAN_V3_ENABLED: 'treatment_plan_v3_enabled',
} as const;

// eslint-disable-next-line local/types-in-types-file -- derived directly from FeatureFlags const; separating would require importing back here
export type FeatureFlagKey = (typeof FeatureFlags)[keyof typeof FeatureFlags];
